export default __webpack_public_path__ + "static/missing-45240ee3d70f08451e57c40bc3bc89a1.jpg";